<template>
  <div class="wrapper" :style="{transform: `translateY(${translate}px)`,transition: transition}">
    <div class="spinner">
      <mt-spinner type="snake" color="#ff6b65" :size="spnsize"></mt-spinner>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    topMethod: {
      type: Function
    }
  },
  data () {
    return {
      transition: 'none',
      translate: 0,
      startY: 0,
      currentY: 0,
      opacity: 0,
      istriggered: false,
      status: 'pull',
      touching: false
    }
  },
  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.$el.addEventListener('touchstart', this.ontouchstart)
      this.$el.addEventListener('touchmove', this.ontouchmove, false)
      this.$el.addEventListener('touchend', this.ontouchend)
    },

    ontouchstart (e) {
      if (this.touching) {
        return
      }
      this.startY = e.touches[0].clientY
      this.touching = true
    },

    ontouchmove (e) {
      if (this.startY < this.$el.getBoundingClientRect().top) {
        return
      }
      this.currentY = e.touches[0].clientY
      let distance = this.currentY - this.startY
      let scrollTop = document.body.scrollTop
      if (distance < 0 || scrollTop !== 0) {
        return
      }
      this.transition = 'none'
      this.status = 'pulling'
      if (this.status === 'pulling') {
        // e.preventDefault()
      }
      const max = 80
      const min = 60
      this.translate = Math.min(distance / 2, max)
      this.opacity = this.translate > min ? 1 : this.translate / max
      this.istriggered = this.translate >= min
    },

    ontouchend (e) {
      if (this.istriggered) {
        this.topMethod && this.topMethod()
      } else {
        this.onloaded()
      }
      this.touching = false
    },

    onloaded () {
      this.transition = 'transform .2s'
      this.translate = 0
      this.opacity = 0
      this.status = 'pull'
      this.istriggered = false
    }
  },

  computed: {
    dpr () {
      // 获取dpr
      let i = 0
      let p = (window.navigator.appVersion.match(/android/gi),
        window.navigator.appVersion.match(/iphone/gi))
      let q = window.devicePixelRatio
      i = p ? q >= 3 && (!i || i >= 3) ? 3 : q >= 2 && (!i || i >= 2) ? 2 : 1 : 1
      return i
    },
    spnsize () {
      return this.i * 15
    }
  }
}
</script>

<style scoped lang="less">
.wrapper{
  position: relative;
  background: #fff;
  .spinner{
    text-align: center;
    position: absolute;
    z-index: 99;
    left:  50%;
    -webkit-transform: translate3d(-50%, -110%, 0);
    transform: translate3d(-50%, -110%, 0);
    span{
      display: inline-block;
    }
  }

}
</style>



// WEBPACK FOOTER //
// pulldown.vue?3e382a2a